import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  Flex,
  Grid,
  MultiSelect,
  Select,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconCalendarMonth, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../model/MessageResponse";
import { CustomerGroup } from "../../../../model/TblDmCustomer";
import {
  listBranch,
  tblPromotion,
  tblPromotionCommand,
} from "../../../../model/TblPromotion";
import { getTblDmEmployeeSelect } from "../../../../service/getSelectApi";
import { validateCreatePromotion } from "../../../../validate/UserCreateModelValidator";
import PromotionConditionModalV2 from "./Components/PromotionConditionModalV2";
import CustomersV2 from "./Components/SetupPromotionPolicy/CustomersV2";
import SaleChannel from "./Components/SetupPromotionPolicy/SaleChannel";
import SuperMarket from "./Components/SetupPromotionPolicy/SuperMarket";
import TableItemGiftPromotion from "./Components/TableItemPromotion/TableItemGiftPromotion";
import TableItemPrimaryPromotion from "./Components/TableItemPromotion/TableItemPrimaryPromotion";

const DetailPromotionPolicyMultiple = () => {
  const navigate = useNavigate();
  let params = useParams();
  const [userSelect, setUserSelect] = useState<SelectListItemBase[]>([]);
  const [selectType, setTypeSelect] = useState<SelectListItemBase[]>([]);
  const [dataBranchProps, setDataBranchProps] = useState<string | null>(null);
  const [dataCustGroupProps, setDataCustGroupProps] = useState<CustomerGroup[]>(
    []
  );
  const [successCall, setSuccessCall] = useState<boolean>(false);
  const _styleGrid = { base: 6, md: 3, lg: 2 };

  const entity = {
    tblPromotionCommand: {
      id: 0,
      code: null,
      type: "0",
      createDate: null,
      createBy: null,
      stopTriggerRule: null,
      note: null,
      approveDate: null,
      approveBy: null,
      approveStatus: null,
      approveNote: null,
      priority: null,
      checkRewardPoint: null,
      checkNomalPromote: null,
      checkMixPromote: null,
      listPaymentMethod: null,
      listSaleChanel: null,
      attribute1: null,
      attribute2: null,
      attribute3: null,
      attribute4: null,
      attribute5: null,
      attribute6: null,
      attribute7: null,
      attribute8: null,
      attribute9: null,
      attribute10: null,
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      listCustGroup: [],
      lisItemPrimary: [],
      listBranch: "",
      ismultiple: false,
    },

    tblPromotionItemPrimaryCommands: [],
    tblPromotionItemAddOnCommands: [],
    tblPromotionItemGiftCommands: [],
  };

  const form = useForm<tblPromotion>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const formHeader = useForm<tblPromotionCommand>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity.tblPromotionCommand,
    },
    validate: validateCreatePromotion,
  });

  const getTypeSelect = async () => {
    var resType = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblPromotion/type");
    if (resType?.httpStatusCode === 200 && resType.data) {
      setTypeSelect(resType.data);
    }
  };

  const fetchUser = async () => {
    const dataseApi = await getTblDmEmployeeSelect();
    setUserSelect(dataseApi);
  };

  const fetchDataDetailPromotion = async (id: number) => {
    const dataApi = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TblPromotion/detail?id=" + id
    );
    if (dataApi && dataApi.success) {
      const result = dataApi.data;
      // listBranch giu nguyen dang chuoi id, SuperMarket tu tra danh muc
      const dataBranch = dataApi.data.tblPromotionDetailModel.listBranch ?? null;
      const dataCustGroup = JSON.parse(
        dataApi.data.tblPromotionDetailModel.listCustGroup as string
      ) as CustomerGroup[];
      setDataBranchProps(dataBranch);
      setDataCustGroupProps(dataCustGroup);
      const dataPromotionCommand = {
        ...result.tblPromotionDetailModel,
        effDate: result?.tblPromotionDetailModel?.effDate
          ? new Date(result?.tblPromotionDetailModel?.effDate)
          : undefined,
        expDate: result?.tblPromotionDetailModel?.expDate
          ? new Date(result?.tblPromotionDetailModel?.expDate)
          : undefined,
        createBy: result?.tblPromotionDetailModel?.createBy
          ? String(result?.tblPromotionDetailModel?.createBy)
          : null,
        listBranch: dataBranch,
        listCustGroup: result?.tblPromotionDetailModel?.listCustGroup
          ? dataCustGroup
          : null,
        countDownDate: result?.tblPromotionDetailModel?.countDownDate
          ? new Date(result?.tblPromotionDetailModel?.countDownDate)
          : undefined,
        listPaymentMethod:
          result?.tblPromotionDetailModel?.listPaymentMethod &&
          result?.tblPromotionDetailModel?.listPaymentMethod?.includes(",")
            ? String(result?.tblPromotionDetailModel?.listPaymentMethod)?.split(
                ","
              )
            : result?.tblPromotionDetailModel?.listPaymentMethod &&
              !result?.tblPromotionDetailModel?.listPaymentMethod?.includes(",")
            ? [String(result?.tblPromotionDetailModel?.listPaymentMethod)]
            : [],
        attribute10: result?.tblPromotionDetailModel?.attribute10
          ? result?.tblPromotionDetailModel?.attribute10
          : null,
        attribute11: result?.tblPromotionDetailModel?.attribute11
          ? result?.tblPromotionDetailModel?.attribute11
          : null,
        attribute12: result?.tblPromotionDetailModel?.attribute12
          ? result?.tblPromotionDetailModel?.attribute12
          : null,
        attribute13: result?.tblPromotionDetailModel?.attribute13
          ? result?.tblPromotionDetailModel?.attribute13
          : null,
        attribute14: result?.tblPromotionDetailModel?.attribute14
          ? result?.tblPromotionDetailModel?.attribute14
          : null,
        attribute15: result?.tblPromotionDetailModel?.attribute15
          ? result?.tblPromotionDetailModel?.attribute15
          : null,
      };
      formHeader.setValues(dataPromotionCommand);
      form.setValues(result);
      setSuccessCall(true);
    }
  };

  const fetchDataItemGiftPromotion = async (id: number) => {
    const dataApi = await repositoryPos.get<MessageResponse<any[]>>(
      `/api/v1/TblPromotion/get-list-gift?PromotionId=${id}&Skip=0&Take=1000`
    );

    if (dataApi && dataApi.success) {
      const result = dataApi.data;
      form.setValues((prev) => ({
        ...prev,
        tblPromotionItemGiftModels: result,
      }));
    }
  };

  useEffect(() => {
    fetchUser();
    getTypeSelect();
    // fetchPromotionCode();
  }, []);

  useEffect(() => {
    fetchDataDetailPromotion(Number.parseInt(params.id ?? ""));
  }, []);

  useEffect(() => {
    if (successCall) {
      fetchDataItemGiftPromotion(Number.parseInt(params.id ?? ""));
    }
  }, [successCall]);

  return (
    <Box>
      <Flex
        align={"center"}
        gap={"md"}
        justify={"space-between"}
        px={"3px"}
        wrap={"wrap"}
      >
        <Text size={"16px"} tt={"uppercase"} fw={"bold"}>
          Chi tiết chính sách khuyến mãi đa điều kiện
        </Text>
        <Flex gap={"md"}>
          <Button
            variant="outline"
            color="red"
            leftSection={<IconX size={14} />}
            // size="xs"
            onClick={() => navigate(-1)}
          >
            Đóng
          </Button>
        </Flex>
      </Flex>
      <Grid>
        <Grid.Col span={12} h={"max-content"}>
          <Box h={"max-content"}>
            <Fieldset
              legend="Thông tin chung"
              // display={"flex"}
              // style={{ flexDirection: "column", gap: "10px" }}
            >
              <Grid>
                <Grid.Col span={_styleGrid}>
                  <TextInput
                    label="Mã CTKM"
                    placeholder="Nhập Mã CTKM"
                    readOnly
                    key={formHeader.key("code")}
                    {...formHeader.getInputProps("code")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <TextInput
                    key={formHeader.key("createBy")}
                    label="Người lập"
                    placeholder="Vui lòng chọn..."
                    readOnly
                    {...formHeader.getInputProps("createBy")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <Select
                    key={formHeader.key("type")}
                    label="Chính sách khuyến mại"
                    placeholder="Vui lòng chọn..."
                    nothingFoundMessage="Không có dữ liệu"
                    data={[
                      { label: "CTKM đa điều kiện", value: "5" },
                      { label: "Combo", value: "3" },
                    ]}
                    readOnly
                    {...formHeader.getInputProps("type")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Thời gian bắt đầu đếm ngược"
                    placeholder="Thời gian bắt đầu đếm ngược"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    readOnly
                    key={formHeader.key("countDownDate")}
                    {...formHeader.getInputProps("countDownDate")}
                  />
                </Grid.Col>
                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Hiệu lực từ ngày"
                    placeholder="Hiệu lực từ ngày"
                    minDate={new Date()}
                    locale="vi"
                    rightSection={<IconCalendarMonth size={14} />}
                    readOnly
                    key={formHeader.key("effDate")}
                    {...formHeader.getInputProps("effDate")}
                  />
                </Grid.Col>

                <Grid.Col span={_styleGrid}>
                  <DateTimePicker
                    label="Đến ngày"
                    placeholder="Đến ngày"
                    locale="vi"
                    readOnly
                    rightSection={<IconCalendarMonth size={14} />}
                    key={formHeader.key("expDate")}
                    {...formHeader.getInputProps("expDate")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2 }}>
                  <MultiSelect
                    key={formHeader.key("attribute2")}
                    label="Chọn phương thức thanh toán"
                    placeholder="Vui lòng chọn phương thức thanh toán"
                    nothingFoundMessage="Không có dữ liệu !"
                    data={[
                      { value: "all", label: "Tất cả" },
                      {
                        value: "offline",
                        label: "Thanh toán khi nhận hàng",
                      },
                      {
                        value: "online",
                        label: "Thanh toán bằng chuyển khoản",
                      },
                      {
                        value: "other",
                        label: "Thanh toán bằng thẻ quốc tế Visa, Master",
                      },
                    ]}
                    searchable
                    value={
                      formHeader.getValues()?.listPaymentMethod &&
                      Array.isArray(formHeader.getValues()?.listPaymentMethod)
                        ? formHeader.getValues()?.listPaymentMethod
                        : []
                    }
                    {...formHeader.getInputProps("listPaymentMethod")}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                  <Select
                    key={formHeader.key("attribute3")}
                    label="Áp dụng"
                    placeholder="Chọn trình duyệt áp dụng"
                    data={[
                      { label: "Áp dụng đồng thời POS và Web", value: "1" },
                      { label: "Chỉ áp dụng trên POS", value: "2" },
                      { label: "Chỉ áp dụng trên Web", value: "3" },
                    ]}
                    {...formHeader.getInputProps("attribute3")}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="Tên CTKM"
                    placeholder="Tên CTKM"
                    withAsterisk
                    key={formHeader.key("note")}
                    {...formHeader.getInputProps("note")}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    key={formHeader.key("attribute5")}
                    {...formHeader.getInputProps("attribute5")}
                    readOnly
                  />
                </Grid.Col>
              </Grid>
              <Grid mt={5}>
                <Grid.Col span={12}>
                  <Flex justify={"start"} align={"center"} gap={"md"}>
                    <Checkbox
                      key={formHeader.key("ismultiple")}
                      label="Áp dụng đồng thời CTKM khác"
                      checked={formHeader.getValues()?.ismultiple}
                      readOnly
                    />
                    {formHeader.getValues()?.type === "4" && (
                      <Checkbox
                        label="Mỗi số điện thoại chỉ được áp dụng 1 lần"
                        checked={formHeader.getValues()?.attribute6 === "true"}
                        readOnly
                      />
                    )}
                  </Flex>
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Box>
        </Grid.Col>

        <Grid.Col span={12}>
          <Tabs
            defaultValue={"primary"}
            styles={{
              tabLabel: { fontWeight: 700, fontSize: 13 },
              panel: {
                overflowX: "visible",
              },
            }}
          >
            <Tabs.List>
              <Tabs.Tab value="primary">Mặt hàng chính</Tabs.Tab>
              {formHeader.getValues()?.type === "1" ? (
                <>
                  <Tabs.Tab value="gift">Mặt hàng tặng</Tabs.Tab>
                </>
              ) : (
                <></>
              )}
              <Tabs.Tab value="quantity">Số lượng</Tabs.Tab>
              <Tabs.Tab value="price">Tổng tiền</Tabs.Tab>
              <Tabs.Tab value="category">Mua cùng danh mục sản phẩm</Tabs.Tab>
              <Tabs.Tab value="bundle">Sản phẩm mua kèm</Tabs.Tab>
              <Tabs.Tab value="type">Mua cùng loại sản phẩm</Tabs.Tab>
              <Tabs.Tab value="brand">Mua cùng chủng sản phẩm</Tabs.Tab>
              <Tabs.Tab value="group">Mua cùng nhóm sản phẩm</Tabs.Tab>
              <Tabs.Tab value="BCPApprove">
                Chi nhánh, khách hàng và kênh bán áp dụng
              </Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="primary">
              <TableItemPrimaryPromotion
                form={form}
                typePromotion={formHeader.getValues()?.type ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="gift">
              <TableItemGiftPromotion form={form} />
            </Tabs.Panel>
            <Tabs.Panel value="quantity">
              <PromotionConditionModalV2
                initialData={"quantity"}
                form={formHeader}
                data={formHeader.getValues()?.attribute15 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="price">
              <PromotionConditionModalV2
                initialData={"price"}
                form={formHeader}
                data={formHeader.getValues()?.attribute14 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="category">
              <PromotionConditionModalV2
                initialData={"category"}
                form={formHeader}
                data={formHeader.getValues()?.attribute13 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="bundle">
              <PromotionConditionModalV2
                initialData={"bundle"}
                form={formHeader}
                data={formHeader.getValues()?.attribute12 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="type">
              <PromotionConditionModalV2
                initialData={"type"}
                form={formHeader}
                data={formHeader.getValues()?.attribute11 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="brand">
              <PromotionConditionModalV2
                initialData={"brand"}
                form={formHeader}
                data={formHeader.getValues()?.attribute9 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="group">
              <PromotionConditionModalV2
                initialData={"group"}
                form={formHeader}
                data={formHeader.getValues()?.attribute10 ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="BCPApprove">
              <Grid>
                <Grid.Col span={{ base: 12, md: 12, lg: 4 }}>
                  <Fieldset legend="Chi nhánh" mt={10}>
                    <SuperMarket form={formHeader} _data={dataBranchProps} />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 12, lg: 4 }}>
                  <Fieldset legend="Đối tượng khách hàng" mt={10}>
                    <CustomersV2 form={formHeader} _data={dataCustGroupProps} />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend={"Kênh bán áp dụng"} mt={10}>
                    <SaleChannel form={formHeader} successCall={successCall} />
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Tabs.Panel>
          </Tabs>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default DetailPromotionPolicyMultiple;
